module.exports = __webpack_public_path__ + "img/bg-icon.6c84a84b.png";